<script setup>
defineProps({
  title: {
    type: String,
  },
  link: {
    type: String,
    default: '#',
  },
  summary: {
    type: String,
  },
})
</script>

<template>
  <div class="results-item prose border-b-2 border-med-light-aqua pb-5 mb-5 lg:pb-[30px] lg:mb-[30px]">
    <h3>
      <a
        v-if="link"
        :href="link"
      >{{ title }}</a>
    </h3>
    <p v-if="summary">
      {{ summary }}
    </p>
  </div>
</template>

<style lang="scss">
.results-item {
    > * {
        &:last-child {
            margin-bottom: 0;
        }
    }
}
</style>
